const en = {
  // Header
  address: "Address",
  home: "Home",
  about: "About",
  schemes: "Schemes",
  howItWorks: "How it Works",
  login: "Login",
  logout : "Logout",

  // Banner
  bannerTitle: "Risk & Welfare Fund Management System",
  bannerTagline: "",
  bannerSubtitle:
    "A unified digital platform for managing Risk & Welfare Scheme for Co-operative Banks/Societies",
  readMore: "Read more",

  // About service cards
  riskFundBeneficiaries: "Risk fund beneficiaries",
  riskFundBeneficiariesDesc:
    "Apply for dead, accident or disability claims and track status",
  applyForClaim: "Apply for Claim",
  societiesAndBanks: "Societies and Banks",
  societiesAndBanksDesc:
    "Registered institutions managing Risk & Welfare Schemes",
  registerSociety: "Register Society",

  // About section
  aboutUsLabel: "About Us",
  aboutRWFMS: "About RWFMS",
  aboutDesc:
    "The Risk & Welfare Fund Management System (RWFMS) enables both beneficiaries and cooperative institutions to efficiently access and manage Risk & welfare schemes.",
  digitalProcessing: "Digital Processing",
  digitalProcessingDesc:
    "Eliminating paperwork with automated end-to-end digital Application workflows.",
  transparentGovernance: "Transparent Governance",
  transparentGovernanceDesc:
    "Real-time tracking and comprehensive public audits for every transaction.",
  swiftDisbursement: "Swift Disbursement",
  swiftDisbursementDesc:
    "Ensure timely disbursement of funds to beneficiaries without any intermediate delays.",

  // Schemes section
  schemesCovered: "Schemes Covered",
  riskFundSchemes: "Risk Fund Schemes",
  riskFundSchemesDesc:
    "The Risk & welfare Fund Management system transitions manual processes into a secure, paperless digital environment for the Kerala Co-operative Development and Welfare Fund Board. Our goal is to ensure that beneficiaries receive their due support without delay and maximum transparency.",
  deathClaimSupport: "Death claim Support",
  deathClaimDesc:
    "The Risk & welfare Fund Management system transitions manual processes into a secure, paperless digital environment for the Kerala Co-operative Development and Welfare Fund Board. Our goal is to ensure that beneficiaries receive their due support without delay and maximum transparency.",
  treatmentClaimSupport: "Treatment Claim Support",
  treatmentClaimDesc:
    "Financial aid for members affected by serious, life-threatening illness.",

  // Welfare section
  welfareFundSchemes: "Welfare Fund Schemes",
  welfareFundSchemesDesc:
"The Welfare Fund Scheme is designed to rehabilitate and strengthen financially weaker co-operative societies. To avail loan assistance in case of financial loss and access the services offered by the Kerala Co-operative Development and Welfare Fund Board (KCDWFB), societies must enroll in the scheme and obtain membership. Through this portal, societies can take new membership, activate existing membership, remit annual contributions, and complete renewal payments seamlessly. This ensures continued eligibility to receive financial support from the Board whenever required.",
  societyEnrollment: "Society Enrollment",
  societyEnrollmentDesc:
    "Streamlined process for societies to join welfare initiatives of Kerala Co-operative Development and Welfare Fund Board.",
  annualRenewal: "Annual Renewal",
  annualRenewalDesc:
    "Automated reminders and simple payment gateways for yearly membership maintenance.",

  // How it Works
  howItWorksLabel: "How it Works",
  easySteps: "Easy 4 steps of the work process",
  register: "Register",
  registerDesc: "Signup as a Beneficiary or Society",
  submitClaim: "Submit Claim",
  submitClaimDesc: "Upload necessary documents online",
  verification: "Verification",
  verificationDesc: "Verification at the society, department & board Level",
  disbursement: "Disbursement",
  disbursementDesc: "Funds transferred directly to Bank",

 // New Registration page
  newRegistration: "New Registration",
  newRegSubtitle: "Enter your details to create an account and start your claim.",
  applicantFullName: "Applicant Full Name",
  emailAddress: "Email Address",
  verifyRegister: "Verify Register",
  alreadyHaveAccount: "Already have an Account?",
  loginHere: "Login here",

  // Login page
  loginWelcome: "Welcome Back",
  loginSubtitle: "Access your risk fund account securely",
  mobileNumber: "Mobile Number",
  enterMobileNumber: "Enter mobile number",
  sendOtp: "Send OTP",
  sending: "Sending...",
  enter6DigitOtp: "Enter 6 Digit OTP",
  dontReceiveCode: "Don't receive code?",
  resend: "Resend",
  verifyOtp: "Verify OTP",
  verifying: "Verifying...",
  newUser: "New User?",
  registerHere: "Register here",

  // Registration page
  societyAccountCreation: "Society Account Creation",
  societyRegSubtitle: "Complete the RWFMS Society Registration to access the administrative portal",
  identification: "Identification",
  societyDetails: "Society Details",
  secretaryDetails: "Secretary Details",
  societyIdentification: "Society Identification",
  societyCategory: "Society Category",
  loadingCategories: "Loading categories...",
  selectCategory: "Select Category",
  societyDistrict: "Society District",
  loadingDistricts: "Loading districts...",
  selectDistrict: "Select District",
  societyTaluk: "Society Taluk",
  loadingTaluks: "Loading taluks...",
  selectDistrictFirst: "Select district first",
  selectTaluk: "Select Taluk",
  branchCode: "Branch Code",
  registrationNumber: "Registration Number",
  enterBranchCode: "Enter Branch Code",
  enterRegistrationNumber: "Enter Registration Number",
  societyName: "Society Name",
  rcsUniqueCode: "RCS Unique Code",
  registeredEmailId: "Registered Email Id",
  verified: "Verified",
  emailVerification: "Email Verification",
  otpSentToEmail: "A new OTP has been sent to your registered email address",
  resendOtp: "Resend OTP",
  verify: "Verify",
  secretaryName: "Secretary Name",
  fullLegalName: "Full Legal Name",
  enterMobileNumberPlaceholder: "Please enter mobile number",
  enterPassword: "Enter Password",
  passwordHint: "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character (@$!%*?&) and min 8 characters.",
  confirmPassword: "Confirm Password",
  declarationText: "I here by declare that the information provided is true to the best of my knowledge and I am authorized to register this society on the administrative portal.",
  registrationSubmittedSuccessfully: "Registration Submitted Successfully",
  bankRegSuccess: "Your bank registration has been completed successfully.",
  societyRegSuccess: "Your society registration has been completed successfully.",
  loginDetailsSentEmail: "Login details have been sent to your registered email address. Please check your email to access your account.",
  goHome: "Go Home",
  saveAndContinue: "Save and Continue",
  registerBtn: "Register",
  back: "Back",

  // User Dashboard
  myClaimsDashboard: "My Claims Dashboard",
  dashboardSubtitle: "Manage and track your government welfare risk fund applications.",
  startNewClaim: "Start New Claim",
  startNewClaimDesc: "Ready to submit a new application? Ensure you have your loan details ready.",
  applyNewClaim: "Apply for New Claim",
  myClaims: "My Claims",
  claimId: "Claim ID",
  loaneeName: "Loanee Name",
  loanNumber: "Loan Number",
  claimType: "Claim Type",
  status: "Status",
  actions: "Actions",
  loadingClaims: "Loading claims...",
  noClaimsYet: "No claims submitted yet.",
  draft: "Draft",
  submitted: "Submitted",
  resume: "Resume",
  loading: "Loading...",
  delete: "Delete",
  view: "View",
  failedToLoad: "Failed to load. Try again.",
  prev: "Prev",
  next: "Next",
  importantInformation: "Important Information",
  claimVerificationNote: "Claim will be verified by Society Secretary/ Bank Manager",
  deleteDraft: "Delete Draft",
  deleteDraftConfirm: "Are you sure you want to delete this draft?",
  cancel: "Cancel",
  deleting: "Deleting...",

  // Loan Details
  selectActiveLoan: "Select Active Loan",
  selectActiveLoanSubtitle: "Please select the specific loan record you wish to process for the current application.",
  fetchLoanError: "Failed to fetch loan details.",
  fetchLoanErrorRetry: "Failed to fetch loan details. Please try again.",
  noLoansFound: "No loans found for this Aadhaar number.",
  failedToLoadClaims: "Failed to load claims. Please refresh the page.",
  failedToDeleteDraft: "Failed to delete draft.",
  searchByNameOrLoan: "Search by name or loan number",
  membershipNo: "Membership No.",
  amount: "Amount",
  noRecordsFound: "No records found for",

  // File Upload
  fileFormatHint: "jpg, pdf, png, up to 2MB",
  clickToBrowse: "Click to browse or drag & drop",
  invalidFileType: "Only jpg, png, pdf files are allowed.",
  fileTooLarge: "File size must be under 2MB.",

  // Death Claim
  deathClaimPageSubtitle: "Submit and manage death claim applications for loanees.",
  deathClaimDetails: "Death Claim Details",
  claimantNamePlaceholder: "Full name as per Aadhaar",
  selectRelationship: "Select relationship",
  loadRelationshipsError: "Failed to load relationships. Please refresh.",
  specifyRelationshipPlaceholder: "Enter relationship with loanee",
  previousDiseaseReliefLabel: "Previous Disease Relief taken",
  yes: "Yes",
  no: "No",
  amountReceived: "Amount Received (₹)",
  dodProofUpload: "DOD Proof Upload",
  uploadDodProof: "Upload DOD Proof",
  uploadDodProofRequired: "Please upload the DOD Proof.",
  deathClaimDraftSavedDesc: "Your death claim draft has been saved. You can continue editing and submit later.",
  claimantNameRequired: "Claimant Name is required.",
  relationshipRequired: "Relationship to Loanee is required.",
  specifyRelationshipRequired: "Please specify the relationship.",
  dateOfDeathRequired: "Date of Death is required.",
  deathCertRequired: "Death Certificate Number is required.",
  releaseAmountRequired: "Release Amount Received is required.",
  ok: "OK",

  // Death Claim Preview
  previewDeathClaimTitle: "Preview of Death Claim",
  deathClaimSubmittedDesc: "Your death claim application has been submitted. You will be notified about the status shortly.",

  // Disease Claim Preview
  previewDiseaseClaimTitle: "Preview of Disease Claim",
  submitting: "Submitting...",
  submit: "Submit",
  claimSubmittedSuccess: "Claim Submitted Successfully!",
  applicationNo: "Application No",
  diseaseClaimSubmittedDesc: "Your disease claim application has been submitted. You will be notified about the status shortly.",
  somethingWentWrong: "Something went wrong. Please try again.",

  // Disease Claim
  diseaseClaimDetails: "Disease Claim Details",
  selectDiseaseCategory: "Select Disease Category",
  searchHospital: "Search hospital / clinic",
  hospitalSearchFailed: "Failed to search hospitals. Please try again.",
  documentsUpload: "Documents Upload",
  additionalDocuments: "Additional Documents (Optional)",
  uploadMedicalCertificate: "Upload Medical Certificate",
  uploadDobProof: "Upload DOB Proof",
  chooseValidDocument: "Valid ID Document",
  uploadIdProofDoc: "Upload ID Proof Document",
  idProofNames: {
    "PAN Card": "PAN Card",
    "Passport": "Passport",
    "Voter ID": "Voter ID",
    "Driving Licence": "Driving Licence",
    "Birth Certificate": "Birth Certificate",
    "SSLC Certificate": "SSLC Certificate",
    "School Leaving Certificate": "School Leaving Certificate",
    "Other Government-issued Document (Containing Date of Birth)": "Other Government-issued Document (Containing Date of Birth)"
  },
  anotherDocument: "Other Document",
  uploadAnotherDoc: "Upload Document",
  anotherDocumentPlaceholder: "Please enter uploaded document name",
  diseaseClaimDeclText: "I hereby declare that the information provided is true and correct to the best of my knowledge. I understand that any false statement may lead to disqualification from the fund benefits.",
  saving: "Saving...",
  saveDraft: "Save Draft",
  previewClaim: "Preview Claim",
  draftSavedTitle: "Draft Saved!",
  draftSavedDesc: "Your disease claim draft has been saved. You can continue editing and submit later.",
  diseaseCategoryRequired: "Disease Category is required.",
  dateOfIllnessRequired: "Date of Illness is required.",
  medicalCertIssuedByRequired: "Medical Certificate Issued by is required.",
  selectHospitalFromSuggestions: "Please select a hospital from the suggestions.",
  dateOfMedCertRequired: "Date of Medical Certificate is required.",
  uploadMedCertRequired: "Please upload the Medical Certificate.",
  uploadDobProofRequired: "Please upload the DOB Proof.",
  medCertDateBeforeIllness: "Date of Medical Certificate cannot be before the Date of Illness.",
  saveDraftError: "Failed to save draft. Please try again.",

  // Claim Loanee Identification
  loaneeIdentPageSubtitle: "Enter loanee details to identify and proceed with your claim application.",
  selectClaimTypeLabel: "Select Claim Type",
  diseaseClaimTitle: "Disease Claim",
  diseaseClaimCardDesc: "Claim due to permanent disability or chronic illness.",
  deathClaimTitle: "Death Claim",
  deathClaimCardDesc: "Claim initiated in the event of the loanee's demise.",
  selectClaimTypeError: "Please select a claim type.",
  loaneeIdentificationLabel: "Loanee Identification",
  loaneeIdentNote: "Enter Aadhaar number of the loanee to retrieve loan details from the system. Ensure the information matches the physical documents.",
  loaneeAadhaarNumber: "Loanee Aadhaar Number",
  enterAadhaarError: "Please enter the Aadhaar number.",
  invalidAadhaarError: "Aadhaar number must be exactly 12 digits.",
  fetching: "Fetching...",
  fetchLoans: "Fetch Loans",

  // Claim View Modal
  loanDetails: "Loan Details",
  loaneeFullName: "Loanee Full Name",
  aadhaarNumber: "Aadhaar Number",
  loanAmount: "Loan Amount",
  societyMembership: "Society Membership #",
  societyAddress: "Society Address",
  dateOfBirth: "Date of Birth",
  birthCertificate: "Birth Certificate #",
  claimDetails: "Claim Details",
  claim: "Claim",
  deathClaimType: "Death",
  diseaseClaimType: "Disease",
  diseaseCategory: "Disease Category",
  dateOfIllness: "Date of Illness",
  hospitalCategory: "Hospital Category",
  medicalCertIssuedBy: "Medical Cert. Issued by",
  medicalCertDate: "Medical Cert. Date",
  claimantName: "Claimant Name",
  relationshipToLoanee: "Relationship to Loanee",
  specifyRelationship: "Specify Relationship",
  dateOfDeath: "Date of Death",
  deathCertificate: "Death Certificate #",
  prevDiseaseRelief: "Prev. Disease Relief",
  releaseAmount: "Release Amount",
  uploadedDocuments: "Uploaded Documents",
  viewDoc: "View Proof",
  medicalCertificate: "Medical Certificate",
  dobProof: "DOB Proof",
  dodProof: "DOD Proof",
  pleaseCheckDeclaration: "Please check the declaration to proceed.",

};

export default en;
